import { useEffect } from "react";

function History() {
  useEffect(() => {
    document.title = "History";
  });
  
  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Our History</h1>
          </div>
          <div class="flex-vert">
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              <img src="/images/about/harrywiess.jpg" style={{ maxWidth: "26%", float: "left", marginRight: "20px", marginBottom: "12px" }} alt="Harry C. Wiess" />
              Welcome to Team Family Wiess! Like any family, we have
traditions and a long history, most of which is passed down
through oral tradition. These stories usually begin with the
phrase, “Back when Wiess was cool...”. You’ll soon learn,
though, that Wiess always has been and always will be cool.
While we’ll never be able to document the vast amounts
of wisdom you’ll pick up from your upperclassman and
alumni friends, we’ll attempt to give you a brief history
of where we’ve been and who we are now. So pull up a
chair and let us tell you about a magical place called Wiess
College (w-I-ess, rhymes with Rice).
              <br />
              <br />
              In the beginning, there was one man. Harry Carothers
Wiess, famed oil tycoon as co-founder of Humble Oil (bought out by
ExxonMobil), left Rice a hefty sum of cash upon his death in 1948 
for the building of a new residential hall to take advantage of an influx
of new students after the GI Bill was signed. The new North Hall opened for
business in 1949, and in 1950 was renamed to Wiess Hall, becoming
the first residential hall to be named after a person. “Old Wiess,” 
as it’s become known, was built to last, and it did, through 2002.
            </p>
            <p class="paragraph-center sub">
              In its modest beginnings, Wiess had only 100 rooms 
and a small Commons. The unique E-shaped (or W-shaped if 
you're a spirited Wiessman) “Motel 6” design with outdoor 
hallways and wrap-around balconies brought instant notoriety 
for its rowdy social atmosphere. The addition of wings to 
the original design split the college into two sections, 
each with their own courtyard and personality: the Acabowl, 
where the action was, and the Backabowl, where a quieter 
atmosphere prevailed for sunbathing or studying. Each 
section was two stories high, with brick veneer walls and 
tiled roofs, and a three-story central wing connecting them. 
The east wing mostly consisted of singles, with doubles everywhere 
else. Bathrooms were semi-private, with each bathroom connecting 
two adjacent rooms. Most rooms also had a window on multiple sides, 
keeping Wiessmen cool before air-conditioning.
            </p>
            <img src="/images/about/oldwiess.jpg" style={{ marginBottom: "20px" }} alt="Old Wiess" />
            <p class="paragraph-center sub">
                In 1957, the residential college system began,
as envisioned by Rice's first president, Edgar Odell Lovett.
The four residential halls (East, South, West, and Wiess)
became Baker College, Will Rice College, Hanszen College,
and Wiess College, respectively. Each had its own dining
hall, Commons, Magisters (then known as Masters),
Resident Associates, and self-governing body of
students. Wiess was renovated to include two Resident 
Associate suites and a new Commons, and Wiess House was constructed as a residence
for the Master and their family. Over time, each college began developing its
own distinctive personality. Wiess identified itself as a
spirited college, this spirit being embraced and embodied
in the colors voted upon in the early days to represent us:
black and gold (which became the goldenrod we know and love
today in the ’80s).
            </p>
            <p class="paragraph-center sub">
                In the early years, certain aspects of Wiess were vastly
different from today. The first master, Dr. Roy Talmage,
was a conservative and strict man. He instituted mandatory
Wiess blazers (which even had crests) for formal Sunday
dinners, where freshmen served upperclassmen a family-style 
dinner while sporting goldenrod and navy beanies
to distinguish themselves (a tradition which, thankfully,
died out quickly). Despite the formality of Sunday supper,
Wiessmen found time to create some of their own
unorthodox customs that became known as distinctly
Wiess.
            </p>
            <p class="paragraph-center sub">
               Life was centered on the outdoors, with the Acabowl
being home to volleyball, frisbee, four-square, and beer bike 
practices. Rogue balls were a constant threat to first-floor
windows. Wiessmen experimented with various short-lived unofficial
innovations, from trampolines to portable swimming 
pools. On occasion, a few students would use
rubber tubing to set up "gazilcher" catapults to launch projectiles,
usually water balloons, towards nearby Hanszen. Other traditions 
included the third-floor dangle, where Wiessmen punish students 
by dangling them off of balconies, and the
Ubangee. Although the Ubangee is still proudly practiced
in a slightly modified form, the dangle disappeared as
human life became more valuable.
            </p>
            <img src="/images/about/wiess1970.jpg" style={{ marginBottom: "20px" }} alt="Wiess in 1970" />
            <p class="paragraph-center sub">
                The ’60s brought fewer milestones to Wiess, but they
did bring one of our proudest traditions. In 1964, an
ambitious Wiessman named George Greanias wrote and
composed a complete musical, "Hello, Hamlet!", spoofing
Shakespeare through creatively re-lyriced show tunes.
He wrote and put on the entire show in a matter of two
weeks. Performances of Hello, Hamlet! continue to grace
the stages of Wiess every four years. It was last performed
in Spring 2016, 2021, and most recently in Spring 2024!
            </p>
            <p class="paragraph-center sub">
                In the ’70s, the Wiess we know today started to take
shape. College rules were relaxed, and women gained
unlimited visiting hours. The commons were renovated
and expanded according to a plan by Wiessmen archis
Tim "Frog" Barry, Dan Canty, and John McCloud that 
they made for a school project. Huge parties, which were the best
on campus, became common. Then came the now-famous
“Team Wiess” cheer derived from a blend of a ’70s Xerox
commercial with the phrase, “Team Xerox,” the movie The
Longest Yard (in which football fans chanted the phrase,
“Mean Machine”), and the TeamBank chain of banks. The
“Team Wiess” cheer made its debut at Beer Bike in 1975
when we celebrated our glorious win. Since then, the
deep, resonating chant has become Wiess’ metaphorical
heartbeat and our trademark on campus.
            </p>
            <p class="paragraph-center sub">
                In 1983, Wiess' mascot, the War Pig, made its debut. 
In 1988, a team of Wiessmen orchestrated the most
notorious jack (prank) ever to go down in Rice history.
Angered by the upcoming hike in tuition, they turned
Willy’s statue around in the quad to face Fondren Library,
thus turning his back on the administration. The jack is still
so legendary today that Rice promotes it as an example of
students’ creativity. Another highlight of the ’80s was the
addition of women to Wiess College, the second-to-last
all-male college. Wiessmen welcomed women to the Wiess
family, and their addition only strengthened the Wiess
spirit and sense of community (and allowed us to dominate
on the powderpuff field). This is when the term Wiessmen
became unisex.
            </p>
            <img src="/images/about/wiess1999.jpg" style={{ marginBottom: "20px" }} alt="Wiess in 1970" />
            <p class="paragraph-center sub">
              By the time the ’90s rolled around, the administration
realized that Old Wiess was literally sinking into the ground
and becoming increasingly structurally unsound. This
prompted the planning of New Wiess, which opened in
the fall of 2002 after some delays. Old Wiess was torn 
down later that winter. We now have an enormous courtyard, 
still called the Acabowl after the old main courtyard, and a
gorgeous Commons. The exterior hallways that were (and
are) the pulse of the college still remain, but since moving
to New Wiess, we’ve also added the Acagliders and the
Acagrills. Since then, we created a distinctive wooden warpig 
in time for Beer Bike 2012 and a whole host of new traditions 
that help make Wiess the fantastic college it is. 
            </p>
            <p class="paragraph-center sub">
                Soon enough, 
you’ll learn all about these traditions. The greatest thing 
about Wiess is that while we hold our traditions near and 
dear to our hearts, we know that there is always room for 
improvement. And unlike other colleges, our spirit, team 
atmosphere, and pride continue long after O-Week is finished. 
While everyone else thinks we’re a pain in the ass, we’re 
pretty crazy about ourselves. And we plan to keep it that way.
            </p>
            <img src="/images/about/newwiess.jpg" alt="Wiess in 1970" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default History;
